import {Component, OnInit} from "@angular/core";
import {ProjectService} from "../../services/project.service";
import {Project} from "../../services/model/projects.model";
import {ActivatedRoute} from "@angular/router";
import {LocationStrategy} from "@angular/common";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-details',
    templateUrl: './details.component.html',
})
export class DetailsComponent implements OnInit{
    project = new Project();
    project_obs;
    back_url: string;
    env = environment;
    bg_color: string;
    detail_form: boolean;
    constructor(
        private projectServ: ProjectService,
        private activeR: ActivatedRoute,
        private locationStg: LocationStrategy
    ){
        const path_list = this.locationStg.path().split('/');
        this.back_url = path_list.length > 1 ? path_list[path_list.length - 2] : 'none';
        this.detail_form = false;
    }

    ngOnInit(){
        const id: string = this.activeR.snapshot.params['id'];
        this.project_obs = this.projectServ.getProject(id);

        this.project_obs.subscribe(
            r => {
                this.project = r;
                this.bg_color = this.env.status[this.project.status != null ? this.project.status: 'default'].color_name;
            }
        )
    }

    clickMenu(){
        console.log('clicked menu');
        this.detail_form = false;
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/details/details.component.ts